module.exports = "https://static.wmbcdn.com/uniweb/images/ac188df79e30ac07907a854b731436fb.svg";